import { UploadedFileType } from 'types/node';
import DocViewer, { DocViewerRenderers, IConfig } from '@cyntler/react-doc-viewer';
import { COLORS } from 'helpers/constants';
import { useEffect, useState } from 'react';
import axios from 'axios';

type Props = {
  node: UploadedFileType;
};

const config: IConfig = {
  header: {
    disableHeader: true,
    disableFileName: false,
    retainURLParams: true,
  },
  loadingRenderer: {
    overrideComponent: () => <div>Loading document...</div>,
    showLoadingTimeout: false,
  },
};

const theme = {
  primary: COLORS.PRIMARY.GRAY,
  secondary: COLORS.PRIMARY.BLUE,
  tertiary: COLORS.PRIMARY.GRAY_LIGHT,
  textPrimary: COLORS.PRIMARY.BLUE,
  textSecondary: COLORS.PRIMARY.GRAY,
  textTertiary: '#00000099',
  disableThemeScrollbar: false,
};

export const DocumentView = ({ node }: Props) => {
  const [docs, setDocs] = useState({
    uri: '',
    fileName: '',
    fileType: 'pdf',
  });

  useEffect(() => {
    async function getCurrentFile() {
      const url = `${process.env.REACT_APP_AWS_DOCUMENT}${encodeURIComponent(node.url)}`;
      const response = await axios.request({
        method: 'GET',
        responseType: 'json',
        url,
      });
      if (response.data) {
        const { data } = response.data;
        setDocs({
          uri: data.url ?? '',
          fileName: node.name ?? 'View',
          fileType: data.ext.split('.')[1],
        });
      }
    }
    getCurrentFile();
  }, [node.name, node.url]);

  return docs.uri ? (
    <DocViewer
      documents={[docs]}
      config={config}
      pluginRenderers={DocViewerRenderers}
      prefetchMethod={undefined}
      theme={theme}
    />
  ) : null;
};
